import { render } from "./carruselComponente-3_ingles.vue?vue&type=template&id=3b10fd0a&scoped=true"
import script from "./carruselComponente-3_ingles.vue?vue&type=script&lang=js"
export * from "./carruselComponente-3_ingles.vue?vue&type=script&lang=js"

import "./carruselComponente-3_ingles.vue?vue&type=style&index=0&id=3b10fd0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b10fd0a"]])

export default __exports__